<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>账号信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div v-loading="loading" style="padding: 15px">
        <div v-if="detailData">
          <el-descriptions title="账号信息" :column="1">
            <template slot="extra">
              <el-button type="default" size="small" @click="editPasswordClick">
                修改密码
              </el-button>
              <el-button type="default" size="small" @click="editClick">
                编辑资料
              </el-button>
              <el-button type="primary" size="small" @click="logoutClick">
                退出登录
              </el-button>
            </template>
            <el-descriptions-item label="账户昵称">
              {{ editModel.nickname }}
              <el-tag
                v-if="editModel.optSuper == 1"
                style="margin-left: 5px"
                size="mini"
                type="success"
              >
                超级管理员
              </el-tag>
              <el-tag
                v-else-if="editModel.roleInfo"
                style="margin-left: 5px"
                size="mini"
                type="primary"
              >
                {{ editModel.roleInfo.roleName || "" }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="登录账户">
              {{ editModel.username }}
            </el-descriptions-item>
            <el-descriptions-item label="所属商户" v-if="editModel.customerInfo">
              {{ editModel.customerInfo.name }}
            </el-descriptions-item>
            <el-descriptions-item label="商户编号" v-if="editModel.customerInfo">
              {{ editModel.customerInfo.guid }}
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">
              {{ new Date(detailData.createTime).format("YYYY-MM-dd hh:mm:ss") }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
          <el-button v-if="errorMsg" @click="getDetail" size="small">
            重新加载
          </el-button>
        </el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
import editPassword from "./editPassword.vue";
import editProfile from "./editProfile.vue";

export default {
  data() {
    return {
      loading: false,
      errorMsg: null,
      detailData: null,
      editModel: {},
    };
  },
  methods: {
    logoutClick() {
      this.openRoutePage("/login");
    },
    editClick() {
      this.$drawer.openDrawer({
        title: "编辑个人资料",
        refresh: this.getDetail,
        component: editProfile,
      });
    },
    editPasswordClick() {
      this.$drawer.openDrawer({
        title: "修改密码",
        refresh: this.getDetail,
        component: editPassword,
        params: {
          noFrame: 0,
        },
      });
    },
    getDetail() {
      this.loading = true;
      this.errorMsg = null;
      this.detailData = null;
      return this.requestApi("biz.customer.account.auth.profile")
        .then((resp) => {
          this.loading = false;
          this.detailData = resp.data;
          this.editModel = Object.assign({}, this.detailData);
          this.commitState({ userProfile: this.detailData });
        })
        .catch((err) => {
          this.loading = false;
          this.errorMsg =
            (err && err.msg) || (err && err.message) || "连接服务器失败，请检查网络";
        });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
